import React, {Component} from 'react';
import './ReportsTabBar.css';
import Label from "../label/Label";
import history from "../../history";
import models from "../../model/models";

export default class ReportsTabBar extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount = () => {
		this.subscribeGroupId = models.user_group.onChange(this.getData);
	}
	componentWillUnmount = () => {
		 models.user_group.unsubscribe(this.subscribeGroupId);
	}
	getData = () => {
	  const userGroup = models.user_group.obj();
		this.setState({userGroup});
	};
	render() {
		const userGroup = this.state.userGroup || {};
		return (
			<div className="g-reports-tab-bar">
				<Label className={window.location.pathname === '/reports/recommended' ? 'active': ''}
							 onClick={() => {
								 history.navigate('/reports/recommended');
							 }}
				>
					Essential Reports
				</Label>
				<Label
					tabIndex="0"
					className={window.location.pathname === '/reports/custom' ? 'active': ''}
					onClick={() => {
						history.navigate('/reports/custom');
					}}
				>
					Saved Reports
				</Label>
				{userGroup.state === 'NY' &&
				<Label
					tabIndex="0"
					className={window.location.pathname === '/forms' ? 'active': ''}
					onClick={() => {
						history.navigate('/forms');
					}}
				>
					Forms
				</Label>}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/reportsTabBar/ReportsTabBar.jsx